import PropTypes from 'prop-types'
import React from 'react'
import PersonalRu from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/Personal/Ru'
import PersonalForeign from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/Personal/Foreign'

const PersonalFormFields = (props) => {
  const { details } = props

  return (
    details?.country_code &&
    (details.country_code === 'ru' ? (
      <PersonalRu {...props} />
    ) : (
      <PersonalForeign {...props} />
    ))
  )
}

PersonalFormFields.propTypes = {
  details: PropTypes.object,
}

export default PersonalFormFields
